import React from 'react';
import styles from './styles/button.module.scss';
import { Spin } from 'antd';
import { motion } from 'framer-motion';

function Button({ text, loading, color = '#4285f4', ...props }) {
    return (
        <motion.button className={styles.button} style={{ backgroundColor: color }} {...props} whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.95 }}>
            {!loading ? text : <Spin size="small" color={'#ffff'} />}
        </motion.button>
    );
}

export default Button;
